module.exports = __webpack_public_path__ + "media/site/images/logos/rubylogic-circle-776ac9e7cab20781fdb338a1754b8a24.svg";